import { APEX_API_URL } from '@/constants';
import {
  ICheckCaptchaResponseModel,
  ICheckPhoneResponseModel,
  ILoginModel,
  IResendActivationModel,
  ISignupModel,
  ISocialLoginParams,
  ITokenModel,
  ITokenResponseModel,
} from '@/interfaces/authentication';
import { getAxiosInstance } from '@/utils/axios-instance';

export const login = async (credentials: ILoginModel): Promise<ITokenResponseModel> => {
  const response = await getAxiosInstance().post(`${APEX_API_URL}/api/auth/verify-otp`, {
    phoneNumber: credentials.phoneNumber,
    otp: credentials.otp,
    otpType: credentials.otpType,
  });
  return response.data;
};

export const signUp = async (credentials: ISignupModel): Promise<ITokenResponseModel> => {
  const response = await getAxiosInstance().post(`${APEX_API_URL}/api/auth/register`, {
    phoneNumber: credentials.phoneNumber,
    dateOfBirth: credentials.dateOfBirth,
    email: credentials.email,
    firstName: credentials.firstName,
    lastName: credentials.lastName,
  });
  return response.data;
};

export const refreshAccessToken = async (tokenObject: ITokenModel): Promise<ITokenResponseModel> => {
  const response = await getAxiosInstance().post(`${APEX_API_URL}/api/auth/refresh`, {
    token: tokenObject.accessToken,
    refreshToken: tokenObject.refreshToken,
  });
  return response.data;
};
export const checkPhoneNumber = async (phoneNumber: string): Promise<ICheckPhoneResponseModel> => {
  const response = await getAxiosInstance().post(`${APEX_API_URL}/api/auth/login`, {
    phoneNumber,
  });
  return response.data;
};

export const checkCaptcha = async (credentials: ILoginModel): Promise<ICheckCaptchaResponseModel> => {
  const response = await getAxiosInstance().post(`${APEX_API_URL}/api/auth/login`, {
    phoneNumber: credentials.phoneNumber,
    captchaToken: credentials.captchaToken,
  });
  return response.data;
};

export const getSessionFromNextServer = async (queryParamString?: string) => {
  const response = await getAxiosInstance().get('/api/auth/session' + (queryParamString ? '?' + queryParamString : ''));
  return response;
};
export const get401 = async (): Promise<any> => {
  const response = await getAxiosInstance().get(`/api/tokens/401`);
  return response;
};
export const verifyEmail = async (hash: string, code: string): Promise<any> => {
  const response = await getAxiosInstance().post(`${APEX_API_URL}/api/auth/verify-email`, {
    hash,
    code,
  });
  return response
};
export const resendActivationEmail = async (email: string): Promise<IResendActivationModel> => {
  const response = await getAxiosInstance().post(`${APEX_API_URL}/api/auth/resend-activation-email`, {
    email,
  });
  return response.data;
};
export const sendOTPThroughEmail = async (phoneNumber: string): Promise<any> => {
  const response = await getAxiosInstance().post(`${APEX_API_URL}/api/auth/send-otp-through-email`, {
    phoneNumber,
  });
  return response.data;
};

export const socialLoginService = async (params: ISocialLoginParams): Promise<any> => {
  const response = await getAxiosInstance().post(`${APEX_API_URL}/api/auth/verify-external-token`, {
    providerSystemName: params.providerSystemName,
    identifier: params.identifier,
    name: params.name,
    firstName: params.firstName,
    lastName: params.lastName,
    idToken: params.idToken,
    accessToken: params.accessToken,
    email: params.email,
  });
  return response.data;
};
export const guestLogIn = async (phoneNumber: string): Promise<any> => {
  const response = await getAxiosInstance().post(`${APEX_API_URL}/api/auth/guest-login`, {
    phoneNumber,
  });
  return response.data;
};
export const updatePhoneNumber = async (customerId: string, newNumber: string, oldNumber: string): Promise<ICheckPhoneResponseModel> => {
  const payload: any = {
    customerId,
    newNumber,
  };
  if (oldNumber) {
    payload.oldNumber = oldNumber;
  }
  const response = await getAxiosInstance().post(`${APEX_API_URL}/api/auth/update-phone-number`, payload);
  return response.data;
};
